<div class="chart-container">
    <canvas id="BarChart">{{ chart }}</canvas>
</div>
